/**
 * The content registry.
 *
 * English is the base. A locale file carries only the strings that have been
 * translated, and everything else falls through to English — so a missing
 * translation degrades to the authoritative wording rather than to a blank.
 */
import {
  BUSINESSES,
  CONTACT,
  FLYWHEEL,
  FOOTER_COLUMNS,
  GOVERNANCE,
  GROUP,
  HOME,
  LEGAL_LINKS,
  NEWSROOM,
  PRIMARY_NAV,
  STRUCTURE_TREE,
  SUSTAINABILITY,
  UI,
  VERIFIED,
} from '../data/content';
import { LEADERSHIP_POSTS, MEDIA_GALLERY } from '../data/media';
import { OUTBOARD_RANGES, SII_LEADERSHIP, WARRANTY_SCREENS } from '../data/people';
import ms from './content.ms';
import zh from './content.zh';

const BASE = {
  BUSINESSES,
  CONTACT,
  FLYWHEEL,
  FOOTER_COLUMNS,
  GOVERNANCE,
  GROUP,
  HOME,
  LEADERSHIP_POSTS,
  LEGAL_LINKS,
  MEDIA_GALLERY,
  NEWSROOM,
  OUTBOARD_RANGES,
  PRIMARY_NAV,
  SII_LEADERSHIP,
  STRUCTURE_TREE,
  SUSTAINABILITY,
  UI,
  VERIFIED,
  WARRANTY_SCREENS,
};

const OVERRIDES = { ms, zh };

const isPlainObject = (value) => Object.prototype.toString.call(value) === '[object Object]';

function merge(base, override) {
  if (override === undefined || override === null) return base;
  if (Array.isArray(base) && Array.isArray(override)) {
    return base.map((item, index) => merge(item, override[index]));
  }
  if (isPlainObject(base) && isPlainObject(override)) {
    const out = { ...base };
    Object.keys(override).forEach((key) => {
      out[key] = merge(base[key], override[key]);
    });
    return out;
  }
  return override;
}

const cache = { en: BASE };

export function getContent(locale) {
  if (!cache[locale]) cache[locale] = merge(BASE, OVERRIDES[locale] || {});
  return cache[locale];
}
